import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.308 11.788a.5.5 0 0 0-.5-.5h-.036a.5.5 0 1 0 0 1h.036a.5.5 0 0 0 .5-.5ZM14.293 11.288a.5.5 0 1 1 0 1h-.035a.5.5 0 0 1 0-1h.035Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14.766 5.614A3.823 3.823 0 0 0 12.053 4.5c-2 0-3.64 1.536-3.808 3.492h-.127c-1.255 0-2.449.918-2.854 2.759a.493.493 0 0 0-.008.043l-.598 4.644c-.232 1.623.111 2.867.932 3.7.809.82 1.99 1.149 3.246 1.149h6.422c1.214 0 2.42-.214 3.247-.99.85-.8 1.17-2.067.902-3.86l-.597-4.643a.496.496 0 0 0-.005-.027c-.175-.947-.575-1.646-1.105-2.11a2.657 2.657 0 0 0-1.752-.665h-.07a3.823 3.823 0 0 0-1.112-2.378Zm.106 2.378A2.824 2.824 0 0 0 12.056 5.5h-.002A2.824 2.824 0 0 0 9.25 7.992h5.622Zm3.546 7.588-.598-4.644c-.143-.756-.446-1.236-.778-1.526a1.657 1.657 0 0 0-1.094-.418h-7.83c-.686 0-1.543.486-1.873 1.953l-.596 4.624v.008c-.204 1.417.114 2.312.653 2.859.553.56 1.43.85 2.534.85h6.422c1.144 0 2.022-.211 2.562-.718.514-.483.842-1.355.598-2.988Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }